export default __webpack_public_path__ + "static/media/paper.fa7fc2be.svg";